import styled from "styled-components";
export const OnBoardingLayoutWrap = styled.div`
  width: 100%;
  @media (min-width: 991px) {
    display: flex;
    justify-content: space-between;
    align-items: stretch;
    min-height: 100vh;
  }
`;
export const ImageWrap = styled.div`
  display: none;
  @media (min-width: 992px) {
    display: block;
    width: 70%;
    position: relative;
    .textWrap {
      position: fixed;
      z-index: 9;
      right: 0;
      bottom: 30px;
      text-align: center;
      padding: 15px;
      color: #fff;
      font-size: 45px;
      line-height: 49px;
      margin: 0 auto;
      left: 50%;
      font-weight: 400;
    }
    img {
      position: fixed;
      top: 0;
      right: 0;
      width: 58%;
      height: 100%;
      object-fit: cover;
      object-position: center;
    }
  }
`;
